import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=0481ea34";
import script from "./AppList.vue?vue&type=script&lang=js";
export * from "./AppList.vue?vue&type=script&lang=js";
import style0 from "./AppList.vue?vue&type=style&index=0&id=0481ea34&prod&lang=less";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;